import { createSlice } from "@reduxjs/toolkit";
import { ResponseApi } from '../BaseApi';
import { CreateFineType, UpdateFineType } from "./FineTypesApi";

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * @description
 * Creates a new Fine Type via POST request to the backend API.
 *
 * This async thunk handles the API communication for fine type creation.
 * On success, it returns the API response data and HTTP status.
 *
 * @async
 * @function CreateFineType
 * @param {Object} params - Request payload containing fine type data (e.g., `{ name: "Speeding" }`).
 * @param {Object} thunkAPI - Thunk API object containing `dispatch` and `getState`.
 * @returns {Promise<{data: Object, status: number}>} API response payload and status code.
 *
 */

const FineTypeSlice = createSlice({
    name: "fineType",
    initialState: {
        addEdit: null,
        mealById: null,
    },
    reducers: {
        resetAddEdit: (state, action) => {
            state.addEdit = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(UpdateFineType.fulfilled, (state, { payload }) => {
            state.addEdit = ResponseApi(payload);
        }).addCase(CreateFineType.fulfilled, (state, { payload }) => {
            state.addEdit = ResponseApi(payload);
        })
    }

})

export const { resetAddEdit } = FineTypeSlice.actions;

export default FineTypeSlice.reducer;
